import { render, staticRenderFns } from "./SysSyncView.vue?vue&type=template&id=0bb8bce4&scoped=true&"
import script from "./SysSyncView.vue?vue&type=script&lang=js&"
export * from "./SysSyncView.vue?vue&type=script&lang=js&"
import style0 from "./SysSyncView.vue?vue&type=style&index=0&id=0bb8bce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8bce4",
  null
  
)

export default component.exports